<template>
<div id="blocklayouter" :class="layouter_cls">

  <div class="align-c">
    <div class="btn btn-outline output-btn" @click="on_click_exit_btn()">Exit</div>
    &nbsp; 
    <div class="btn btn-outline output-btn" @click="on_click_save_btn()">Save</div>
  </div>

  <div class="blocks">

    <pre v-if="0">{{blocks_local}}</pre>
    
    <div class="addblock-area" v-if="movingBlockFromPosition == undefined" @_mouseleave="deactiveAddBlockAreas()">
      <div v-for="(type,type_i) in layout_types" :key="'jbdj'+type_i" :class="'layout-btn l'+type" @click="addBlock(type,-1)"><div></div><div></div><div></div></div>
      <div class="activate-btn" @click="activateAddBlockArea($event, -1)">Add block</div>
    </div>
    
    <div class="dropblock-btn" v-if="movingBlockFromPosition != undefined" @click="moveBlockToPosition(0)">
      Move block to this position
    </div>
    
    <div class="block" 
      v-for="(block,block_i) in blocks_local" 
      :class="block_cls(block,block_i)" 
      :key="'block'+block_i" 
      :data-i="block_i"
      bag="my-bag"
      @_dragstart="block_dragstart($event,block,block_i)"
      @_dragover="block_dragover($event,block,block_i)"
      @_dragend="block_dragend($event,block,block_i)"
    >
      <div class="pieces">
        
        <div class="piece" 
          v-for="(piece,piece_i) in block.pieces" 
          :key="'jbdf'+piece_i" 
          :style="piece_css(piece)" 
          :class="piece_cls(piece)"
          :data-i="piece_i"
          draggable="true" 
          @dragstart.stop="piece_dragstart($event,piece,piece_i,block,block_i)"
          @dragover.stop="piece_dragover($event,piece,piece_i,block,block_i)"
          @dragenter.stop="piece_dragenter($event,piece,piece_i,block,block_i)"
          @dragleave.stop="piece_dragleave($event,piece,piece_i,block,block_i)"
          @dragend.stop="piece_dragend($event,piece,piece_i,block,block_i)"
        >
          <div v-if="item_title(piece)" class="piece-title">{{item_title(piece)}}</div>
          
          <div class="piece-action-btn clear-piece-btn" v-if="!pieceIsEmpty(piece)" @click="clearPiece($event,block,block_i,piece,piece_i)" :class="{sure:( clearingPiece == block_i+'-'+piece_i )}" @mouseleave="clearingPiece = undefined">
            {{ ( clearingPiece == block_i+'-'+piece_i ) ? 'Sure?' : 'X' }}
          </div>
          
          <div class="populate-piece-btn" v-if="pieceIsEmpty(piece)" @click="populatePiece(block,block_i,piece,piece_i)">+</div>

          <div class="postpopulate-piece-btn" v-if="show_postpopulate_btn(piece)" @click="postPopulatePiece(block,block_i,piece,piece_i)">{{postpopulate_btn_title(piece)}}</div>

          <div class="piece-media-info-btn" v-if="showPieceMediaMetaBtn(piece)" @click="pieceMediaMetaBtnClick(piece)">=</div>

          <div class="populate-minimenu" v-if="populating_item == block_i+'-'+piece_i" @mouseleave="populating_item=undefined">
            <div class="mbtn" @click="populatePiece_type( 'media', block, block_i, piece, piece_i )">Image/video</div>
            <div class="mbtn" @click="populatePiece_type( 'model', block, block_i, piece, piece_i )">Model link</div>
            <div class="mbtn" @click="populatePiece_type( 'artist', block, block_i, piece, piece_i )">Artist link</div>
            <div class="mbtn" @click="populatePiece_type( 'influencr', block, block_i, piece, piece_i )">Influencer link</div>
            <div class="mbtn" @click="populatePiece_type( 'page', block, block_i, piece, piece_i )">Page link</div>
          </div>
          
        </div>

        <div class="block-r-btns">
          <div class="block-r-btn block-remove-btn" @click="on_click_remove_block_btn($event,block,block_i)">X</div>
          <div class="block-r-btn block-move-up-btn" v-if="false" @click="on_click_move_block_up_btn(block_i)" :class="{'off':!( block_i > 0 && blocks_local.length > 1 )}">/\</div>
          <div class="block-r-btn block-move-down-btn" v-if="false" @click="on_click_move_block_below_btn(block_i)" :class="{'off':!((block_i+1) < blocks_local.length && blocks_local.length > 1)}">\/</div>
          <div class="block-r-btn block-move-drag-btn" v-if="false" @mouseenter="block_drag_btn_enter($event)" @mouseleave="block_drag_btn_leave($event)">M</div>
          <div class="block-r-btn block-move-drag-btn" @click="moveBlockFromPosition(block_i)">M</div>
          <div class="block-r-btn block-toggle-hide-btn" @click="on_click_toggle_block_hide_btn(block)">H</div>
          <div class="block-r-btn block-shuffle-layout-btn" v-if="show_layout_shuffle_btn(block)" @click="on_click_shuffle_block_layout_btn(block_i)" :class="{'off':(block.layout=='1')}">L</div>
        </div>

        <div class="block-drop-areas" v-if="false && dnd.dnd_blockmode">
          <div class="top"
            @dragenter.stop="block_drop_area_on_dragenter($event,block,block_i)"
            @dragleave.stop="block_drop_area_on_dragleave($event,block,block_i)"
            @dragend.stop="block_drop_area_on_dragend($event,block,block_i,-1)"
          ></div>
          <div class="bottom"
            @dragenter.stop="block_drop_area_on_dragenter($event,block,block_i)"
            @dragleave.stop="block_drop_area_on_dragleave($event,block,block_i)"
            @dragend.stop="block_drop_area_on_dragend($event,block,block_i,1)"
          ></div>
        </div>

      </div><!-- .pieces -->

      <div class="pageblocksmax-marker" v-if=" pageblocksmax_marker_i == block_i ">
        <span>Blocks below this will not be shown</span>
      </div>

      <div class="addblock-area" v-if="movingBlockFromPosition == undefined" @_mouseleave="deactiveAddBlockAreas()">
        <div v-for="(type,type_i) in layout_types" :class="'layout-btn l'+type" :key="'lwkd'+type_i" @click="addBlock(type,block_i)"><div></div><div></div><div></div></div>
        <div class="activate-btn" @click="activateAddBlockArea($event, block_i)">Add block</div>
      </div>

      <div class="dropblock-btn" v-if="movingBlockFromPosition != undefined" @click="moveBlockToPosition(block_i+1)">
        Move block to this position
      </div>

    </div><!-- .block -->    
    
  
    <div class="contents" v-if="false">
      <div class="title">Unused images</div>
      <div class="content" 
        v-for="(content,content_i) in content" 
        :style="contentStyle(content)" 
        :key="'dkwn'+content_i" 
        :data-val="content.val" 
        v-if="!isContentInBlocks(content)"
      ></div>
    </div>

  </div><!-- .blocks -->

  <div class="align-c">
    <div class="btn btn-outline output-btn" @click="on_click_exit_btn()">Exit</div>
    &nbsp; 
    <div class="btn btn-outline output-btn" @click="on_click_save_btn()">Save</div>
  </div>

  
</div>    
</template>

<script>

import helpers from '../.././helpers.js'
import mixins from '../.././mixins.js'
import axios from 'axios'; import qs from 'qs'
import $ from 'jquery'
import draggable from 'vuedraggable'


export default {
  props: [ 'blocks' ],
  mixins: [ mixins.generic ],
  props: [ 
    'route_name',
    'page_slug',
    'book_slug',
    'model',
    'artist',
    'influencer',
    'page',
    'blocks',
  ],
  components: { 
    draggable
  },
  data(){ return {

    blocks_local: [],

    populating_item: undefined,
    populating_piece_type: undefined,

    clearingPiece: undefined,

    dnd: {
      dnd_blockmode: false,
      dnd_piecemode: false,
      a_block: { block_i:undefined, },
      b_block: { block_i:undefined, },
      a_piece: { block_i:undefined, piece_i:undefined, },
      b_piece: { block_i:undefined, piece_i:undefined, },      
    },

    block_dragging: false,

    movingBlockFromPosition: undefined,

    //content: window.active_blocklayout,
    //content_metadata: window.active_blocklayout_metadata,

    content_modified: false,

  }},
  computed:{

    layouter_cls(){
      var  cls = {}
      if( this.dnd.dnd_blockmode ) cls['blocks-droppable'] = true
      return cls
    },

    layout_types(){

      // check route instead of body class - class names have changed anyways
      // can you access route here? instead use params passed to this editor
      // param: routename, book

      var rt = this.route_tags
      
      if( rt.model_single ) {
        if( this.book_slug == 'polaroids' ) return [ '1-1', '1', 'H',  ]
        if( this.book_slug == 'runway' ) return [ '1-1', '1', 'H', ]
      }

      // artist?

      return [
        '1', '1-1', '1-1-1',
        '1-2', '2-1',                        
        '2-1-1', '1-1-2',
        'H',
      ]

    },


    blockDragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'drag-ghosted'
      };
    },


    pageblocksmax_marker_i(){
      
      //this.$store.state.blocks_max.model.portfolio  

      if( this.model && this.book_slug && this.book_slug == 'portfolio' ) var i = this.$store.state.blocks_max.model.portfolio
      if( this.model && this.book_slug && this.book_slug == 'runway' ) var i = this.$store.state.blocks_max.model.runway
      if( this.model && this.book_slug && this.book_slug == 'polaroids' ) var i = this.$store.state.blocks_max.model.polaroids

      if( !i ) return undefined

      i -= 1
      return i
    },

    hasHideBlock(){ return helpers.blocks_contains_type(this.blocks, 'H') },

    
  },
  methods: {
   
    block_cls(block,block_i) {
      var cls = {}
      cls[ 'layout-'+block.layout ] = true

      if(block.hide) cls[ 'block-hidden' ] = true

      if( block_i + 1 == this.movingBlockFromPosition ) cls['pre-moving-block'] = true
      if( block_i == this.movingBlockFromPosition ) cls['moving-block'] = true

      return cls
    },

    piece_cls(piece) {
      var output = {}
      if( !piece ) output['piece-empty'] = true
      if( !this.pieceIsEmpty(piece) ) output['piece-populated'] = true
      return output
    },

//------------------------------------------------------------------------------------------------

    piece_css( piece ) {
      var output = {}
      if( !piece ) return

      var media = undefined
      var cachebuster = undefined
      var img_url = undefined

      var metadata = piece.metadata
      if( metadata ) {
        media = ( metadata.block_media || metadata.media )
        if( media ) cachebuster = media.cachebuster
      }

      if( piece.img_url )  img_url = piece.img_url
      if( piece.media_id ) img_url = this.mediaUrl( piece.media_id, 900, 'jpg')

      if( piece.type == 'page' && metadata ) {
        if( metadata.block_media ) img_url = this.mediaUrl( metadata.block_media.id, 900, 'jpg')
        if( metadata.media ) img_url = this.mediaUrl( metadata.media.id, 900, 'jpg')
      }

      if( media && ( media.type == 'vimeo' || media.type == 'youtube' ) ) {
        img_url = this.mediaVideoThumbnailImg(media)
      }      

      if( !img_url ) return

      if( cachebuster ) img_url += '?' + cachebuster + ''

      output['background-image'] = 'url('+img_url+')'
      return output
    },

//------------------------------------------------------------------------------------------------

    contentStyle(content) {
      return
      var output = {}
      if( !content ) return
      output['background-image'] = 'url(img'+content.val+'.png)'
      return output
    },

    item_title(piece) {
      if( !piece ) return
      if( piece.metadata && piece.metadata.title ) return piece.metadata.title
      if( piece.metadata && piece.metadata.model && piece.metadata.model.full_name ) return piece.metadata.model.full_name
      if( piece.metadata && piece.metadata.page && piece.metadata.page.title ) return piece.metadata.page.title
      if( piece.metadata && piece.metadata.media && piece.metadata.media.type && piece.metadata.media.type && piece.metadata.media.type != 'image' ) return piece.metadata.media.type
      return piece.title
    },

    isContentInBlocks(content){
      return false
      if(!content) return false
      if(!content.val) return false
      if( !this.content ) return false
      for( var i = 0; i < this.blocks_local.length; i++ ) {
        var block = this.blocks_local[i]
        for( var ii = 0; ii < block.pieces.length; ii++ ) {
          var piece = block.pieces[ii]
          if( piece == content.val ) return true
        }
      }
      return false
    },

    show_layout_shuffle_btn(block){
      if( block.layout == 'H' ) return false
      return true
    },

    
    block_drag_btn_enter(e){
      e.target.closest('.block').setAttribute('draggable','true')
    },

    block_drag_btn_leave(e){
      e.target.closest('.block').removeAttribute('draggable')
    },

    on_click_toggle_block_hide_btn(block){
      var hide = block.hide
      if( hide == undefined ) hide = false
      this.$set( block, 'hide', !hide )
    },

    removeBlock(block,block_i) {
      if( !this.content ) return false
      this.blocks_local.splice(block_i,1)          
    },        


    addBlock( layout, insertAt ) {
      var piececount = layout.split('-').length
      if( piececount == 1 ) var pieces = [undefined]
      if( piececount == 2 ) var pieces = [undefined,undefined]
      if( piececount == 3 ) var pieces = [undefined,undefined,undefined]
      var new_block = {
        layout: layout,
        pieces: pieces
      }

      
      if( !this.blocks_local.length ) {
        this.blocks_local.push(new_block)
      } else {
        if( insertAt == -1 ) this.blocks_local.unshift(new_block)
        if( insertAt == 0 ) this.blocks_local.splice(1,0,new_block)
        if( insertAt > 0 ) this.blocks_local.splice(insertAt+1,0,new_block)
      }

      this.deactiveAddBlockAreas()
      
    },

    activateAddBlockArea(e, insertAt ){

      if( this.layout_types.length == 1 ) {
        var layout = this.layout_types[0]
        this.addBlock( layout, insertAt )
        return
      }

      $('.addblock-area.active').removeClass('active')
      $(e.target).parent('.addblock-area').addClass('active')
    },

    deactiveAddBlockAreas(){
      $('.addblock-area.active').removeClass('active')
    },

    
    arrayFilterUndefineds(arr){
      return $.grep(arr,function(n){ return n == 0 || n })
    },

    clearPiece(e,block,block_i,piece,piece_i) {

      //var sure = prompt('Are you sure? Type "ok" to continue...')
      //if( sure.toLowerCase() != 'ok' ) return

      //var sure = confirm('Are you sure?')
      //if(!sure) return

      if( this.clearingPiece != block_i+'-'+piece_i ) {
        this.clearingPiece = block_i+'-'+piece_i
        return
      }

      this.clearingPiece = undefined
      this.$set( block.pieces, piece_i, undefined )
    },

//------------------------------------------------------------------------------

    populatePiece( block, block_i, piece, piece_i )
    {

      var rt = this.route_tags

      if( rt.model_single ) var type = 'media'
      if( rt.artist_single ) var type = 'page'
      if( rt.influencer_single ) var type = 'media'

      if( rt.page ) var type = 'page'
      
      this.populatePiece_type( type, block, block_i, piece, piece_i )
      return
  
      // trigger populate minimenu. No longer used, though
      this.populating_item = block_i+'-'+piece_i
    },

//------------------------------------------------------------------------------

    populatePiece_type( type, block, block_i, piece, piece_i ){
      this.populating_item = undefined
      this.populating_piece_type = type

      this.selectFromMediaLib( type, block, block_i, piece, piece_i )
    },

//------------------------------------------------------------------------------

    selectFromMediaLib( type, block, block_i, piece, piece_i )
    {
      
      var _this = this

      // CALLBACK ----------
      this.$store.commit('set_admin_medialib_on_media_select', function(items){

            var item = items[0] // only allow the first to be used        

            for( let i = 0; i < items.length; i++ ) {

              var item = items[i]

              var pieceIndex = piece_i
              
              if( !_this.pieceIsEmpty(block.pieces[pieceIndex]) ) {  
                // piece not empty, finding next piece empty in block
                pieceIndex = _this.blockGetEmptyPieceIndex(block)
              }

              // no more empty pieces in block, gotta create new block
              if( pieceIndex === false ) {
                _this.addBlock('1-1', block_i )
                block_i += 1
                block = _this.blocks_local[block_i]
                pieceIndex = _this.blockGetEmptyPieceIndex(block)
              }
                          
              var populating_piece_type = _this.populating_piece_type
              //_this.populating_piece_type = undefined

              var newpiece = {
                type: populating_piece_type,
                metadata: {},
              }

              if( item.type == 'page' ) {
                //newpiece.media_id = item.id // this needs to be found as well
                newpiece.page_id = item.page_id
                newpiece.metadata.title = title = item.title
                newpiece.metadata.block_media = item.block_media
              }

              if( populating_piece_type == 'media' ) {
                newpiece.media_id = item.id
              }        

              if( populating_piece_type == 'media' ) {
                if( item.type == 'youtube' || item.type == 'vimeo' ) {
                  var title = ( item.title || 'Video' )
                  newpiece.metadata.title = title
                  newpiece.metadata.video_type = item.type
                  newpiece.metadata.video_slug = item.video_slug
                }
              }

              if( populating_piece_type == 'model' ) {
                newpiece.media_id = item.id
                newpiece.model_id = item.model_id
                newpiece.metadata.title = 'Model'                
              }

              _this.$set( block.pieces, pieceIndex, newpiece)

              console.log({ pieces:block.pieces, pieceIndex, newpiece })
              

            } // foreach items


      }) // set_admin_medialib_on_media_select
      // CALLBACK ----------

      var modal_data = { multiselection_enabled: true }

      var rn = this.route_name
      var rt = this.route_tags
      
      if( rt.model_single ) {
        this.medialib_visibles({ models_media:1, artists_media:1, influencers_media:1, other_media:1, contentpages:0, newsarticles:0, artistgalleries:0, })
        if( this.model ) modal_data.active_folder_id = 6000000 + this.model.id
      }

      if( rt.artist_single ) {
        this.medialib_visibles({ models_media:1, artists_media:1, influencers_media:1, other_media:1, contentpages:0, newsarticles:1, artistgalleries:1, })
        //if( this.artist ) modal_data.active_folder_id = 6000000 + this.artist.id        
        modal_data.active_folder_id = 9000013        
      }

      if( rt.page ) {
        this.medialib_visibles({ models_media:0, artists_media:0, influencers_media:0, other_media:0, contentpages:1, newsarticles:1, artistgalleries:1, })
        modal_data.active_folder_id = null
      }
      
      this.medialib_open(modal_data)
      
    },

//------------------------------------------------------------------------------

    show_postpopulate_btn(piece) {
      if( !piece ) return false
      if( piece.type && piece.type == 'page' ) return true
      return false
    },

//-----------------------------------------------------------------------------------------

    postpopulate_btn_title(piece){
      if( !piece ) return '?'
      if( piece.type && piece.type == 'page' ) return 'Change image'
      return '?'
    },

//-----------------------------------------------------------------------------------------

    postPopulatePiece( block, block_i, piece, piece_i )
    {

      if( this.route_tags.page ) var type = 'page'
      
      if( type == 'page' ) this.medialib_visibles({ models_media:1, artists_media:1, influencers_media:1, other_media:1, contentpages:0, newsarticles:0, artistgalleries:0, })

      var _this = this

      this.$store.commit('set_admin_medialib_on_media_select', function(items){

        var item = items[0] // use first (only) media - multiple medias not allowed for this action

        if( item.type != 'image' && item.type != 'youtube' && item.type == 'vimeo' ) return

        _this.$set( piece, 'media_id', item.id )
        _this.$set( piece, 'block_media_id', item.id )
        
        // -- for editor visibility only - will be filtered away on save ------------
        if( !piece.metadata ) _this.$set( piece, 'metadata', {} )
        if(piece.metadata.media)_this.$set( piece.metadata, 'media', item )          
        if(piece.metadata.block_media) _this.$set( piece.metadata, 'block_media', item )          
        // -- for editor visibility only - will be filtered away on save ------------

      })

      var modal_data = { multiselection_enabled: false }
      
      if( this.model ) {
        this.medialib_visibles({ models_media:1, artists_media:1, influencers_media:1, other_media:1, contentpages:0, newsarticles:0, artistgalleries:0, })
        modal_data.active_folder_id = 6000000 + this.model.id
      }
      
      if( this.artist ) {
        this.medialib_visibles({ models_media:1, artists_media:1, influencers_media:1, other_media:1, contentpages:0, newsarticles:0, artistgalleries:0, })
        modal_data.active_folder_id = 7000000 + this.artist.id
      }

      this.medialib_open(modal_data)      

    },

//-----------------------------------------------------------------------------------------

    blockIsEmpty(block){
      if( !block || !block.pieces || !block.pieces.length ) return true
      for( var i = 0; i < block.pieces.length; i++ ) {
        if( !this.pieceIsEmpty(block.pieces[i]) ) return false
      }
      return true
    },

//-----------------------------------------------------------------------------------------

    blockIsFull(block){
      if( !block || !block.pieces || !block.pieces.length ) return true
      for( var i = 0; i < block.pieces.length; i++ ) {
        if( this.pieceIsEmpty(block.pieces[i]) ) return false
      }
      return true
    },

//-----------------------------------------------------------------------------------------

    // will return 0,1,2, etc. or false if none

    blockGetEmptyPieceIndex(block){
      for( var i = 0; i < block.pieces.length; i++ ) {
        if( this.pieceIsEmpty(block.pieces[i]) ) return i
      }
      return false
    },
    
//-----------------------------------------------------------------------------------------

    pieceIsEmpty(piece){
      if( !piece ) return true
      if( piece === {} ) return true
      //if( isEmpty(piece) ) return true
      return false
    },

//-----------------------------------------------------------------------------------------

    on_click_remove_block_btn(e,block,block_i){
      //var sure = prompt('Are you sure? Type "ok" to continue...')
      //if( sure.toLowerCase() != 'ok' ) return

      var is_empty = this.blockIsEmpty(block)

      if( !is_empty ) {
        var sure = confirm('Are you sure?')
        if(!sure) return
      }
      
      /*
      if( !$(e.target).hasClass('sure') ) {
        $(e.target).addClass('sure')
        return
      }
      */
      this.blocks_local.splice( block_i,1 )          
    },

//-----------------------------------------------------------------------------------------

    on_click_move_block_up_btn(block_i){
      var newIndex = block_i - 1
      if( newIndex < 0 ) newIndex = 0
      this.blocks_local.splice(newIndex, 0, this.blocks_local.splice(block_i, 1)[0])      
    },

//-----------------------------------------------------------------------------------------

    on_click_move_block_below_btn(block_i){
      var newIndex = block_i + 1
      if( newIndex > this.blocks_local.length ) newIndex = this.blocks_local.length
      this.blocks_local.splice(newIndex, 0, this.blocks_local.splice(block_i, 1)[0])
    },

//-----------------------------------------------------------------------------------------

    on_click_shuffle_block_layout_btn(block_i){
      var block = this.blocks_local[block_i]
      var layout = block.layout
      
      if( layout == '1-1-1' ) this.blocks_local[block_i].layout = '1-1-2'
      if( layout == '1-1-2' ) this.blocks_local[block_i].layout = '2-1-1'
      if( layout == '2-1-1' ) this.blocks_local[block_i].layout = '1-1-1'

      if( layout == '1-1' ) this.blocks_local[block_i].layout = '1-2'
      if( layout == '1-2' ) this.blocks_local[block_i].layout = '2-1'
      if( layout == '2-1' ) this.blocks_local[block_i].layout = '1-1'
      
    },
    
//-----------------------------------------------------------------------------------------    

    block_dragstart(e,block,block_i){      
      this.dnd.dnd_blockmode = true
      this.dnd.dnd_piecemode = false
    },

//-----------------------------------------------------------------------------------------

    block_dragover(e,block,block_i){      
      this.dnd.b_block.block_i = block_i      
    },

//-----------------------------------------------------------------------------------------

    block_dragend(e,block,block_i){
      this.dnd.dnd_blockmode = false
      this.dnd.dnd_piecemode = false

      var a_block_i = block_i
      var b_block_i = this.dnd.b_block.block_i 
      //console.log( a_block_i + ' > ' +b_block_i, )
      var tmp_a = this.blocks_local[ a_block_i ]
      var tmp_b = this.blocks_local[ b_block_i ]
      
      //this.$set( this.blocks_local, a_block_i, JSON.parse(JSON.stringify(tmp_b)) )
      //this.$set( this.blocks_local, b_block_i, JSON.parse(JSON.stringify(tmp_a)) )

      //console.log( 'dragged old index '+a_block_i+' new index '+b_block_i+' offset '+newPosOffset )

      var newPosOffset = b_block_i - a_block_i
      //this.arrayMove( this.blocks_local, a_block_i, newPosOffset )

    },

//-----------------------------------------------------------------------------------------

    block_drop_area_on_dragenter(e,block,block_i){
      e.target.classList.add('dragged-over')
    },

//-----------------------------------------------------------------------------------------

    block_drop_area_on_dragleave(e,block,block_i){
      e.target.classList.remove('dragged-over')
    },

//-----------------------------------------------------------------------------------------

    block_drop_area_on_dragend(e,block,block_i,offset){

      this.dnd.dnd_blockmode = false
      this.dnd.dnd_piecemode = false

      var a_block_i = block_i
      var b_block_i = this.dnd.b_block.block_i 

      var new_i = block_i + offset
      if( new_i < 0 ) new_i = 0
      
      console.log( '-- dragged old index '+a_block_i+' new index '+b_block_i+' offset '+offset )
    },

//-----------------------------------------------------------------------------------------

    piece_dragstart(e,piece,piece_i,block,block_i){            
      this.dnd.dnd_blockmode = false
      this.dnd.dnd_piecemode = true
    },
    
//-----------------------------------------------------------------------------------------

    piece_dragover(e,piece,piece_i,block,block_i){
      this.dnd.b_piece.block_i = block_i
      this.dnd.b_piece.piece_i = piece_i
    },

//-----------------------------------------------------------------------------------------

    piece_dragenter(e,piece,piece_i,block,block_i){
      if( this.dnd.dnd_piecemode ) e.target.classList.add('dragged-over')
    },

//-----------------------------------------------------------------------------------------

    piece_dragleave(e,piece,piece_i,block,block_i){
      e.target.classList.remove('dragged-over')
    },
    
//-----------------------------------------------------------------------------------------

    piece_dragend(e,piece,piece_i,block,block_i){
      
      this.dnd.dnd_blockmode = false
      this.dnd.dnd_piecemode = false

      var a_block_i = block_i
      var a_piece_i = piece_i
      
      var b_block_i = this.dnd.b_piece.block_i 
      var b_piece_i = this.dnd.b_piece.piece_i     

      //console.log( a_block_i +'/'+ a_piece_i + ' > ' + b_block_i +'/'+ b_piece_i, )
      
      var tmp_a = this.blocks_local[ a_block_i ].pieces[ a_piece_i ]
      var tmp_b = this.blocks_local[ b_block_i ].pieces[ b_piece_i ]
      if( tmp_a === undefined ) tmp_a = null
      if( tmp_b === undefined ) tmp_b = null

      this.$set( this.blocks_local[ a_block_i ].pieces, a_piece_i, JSON.parse(JSON.stringify(tmp_b)) )
      this.$set( this.blocks_local[ b_block_i ].pieces, b_piece_i, JSON.parse(JSON.stringify(tmp_a)) )

    },

    arrayMove(arr, oldIndex, offset) {
      const index = arr.indexOf(oldIndex);
      const newIndex = index + offset;
      if ((newIndex > -1) && (newIndex < arr.length)) {
        const removedElement = arr.splice(index, 1)[0];
        return arr.splice(newIndex, 0, removedElement);
      }
    },
    
    on_click_exit_btn(){
      //this.$emit('close')

      if( this.content_modified ) {
        var sure = confirm('You have unsaved changes - Sure you want to exit without saving?')
        if(!sure) return
      }

      this.$emit('onexit')

      this.$store.commit('set_editing_blocks', false)

    },

//-----------------------------------------------------------------------------------------

    on_click_save_btn(){
      
      var blocks = this.blocks_local
      blocks = helpers.strip_blocks_pieces_metadata(blocks)
      
      //console.log(blocks)
      //return
      
      var new_blocklayout_data = { blocks:JSON.parse(JSON.stringify(blocks)) }      
      var new_blocklayout_data_json = JSON.stringify(new_blocklayout_data)

      //Site.bigSpinner(true)
      var _this = this

      var input = {
        access_token: this.$store.state.loggedin_user.access_token,
        json: new_blocklayout_data_json,
      }

      if( this.model ) input.model_id = this.model.id
      if( this.artist ) input.artist_id = this.artist.id
      if( this.influencer ) input.influencer_id = this.influencer.id

      if( this.book_slug ) input.book = this.book_slug
      if( this.page_slug ) input.page_key = this.page_slug

      if( this.is_site_am ) input.page_key = 'a-management.eu/' + input.page_key

      return axios.post( this.$store.state.api_url + 'admin_blocklayouter_save', qs.stringify(input) )
				.then(function(result){
          var output = result.data
          if( !_this.validateApiOutput(output) ) return
          
          if( !output || !output.status || output.status != 'success' || output.error ) {
            console.log('error',output.error); return
            _this.msg('Error - could not save')
          }

          _this.content_modified = false

          _this.triggerIconSignal('check')
          //_this.$store.commit('set_editing_blocks', false)

          _this.$emit('updated')
          
				})
				.catch(function(error){					
          console.log('error',error)
          _this.msg('Error - could not save')
        })
        

    },

//-----------------------------------------------------------------------------------------

    moveBlockFromPosition(block_i) {
      if( this.movingBlockFromPosition != undefined ) {
        this.movingBlockFromPosition = undefined
        return
      }
      this.movingBlockFromPosition = block_i
    },

//-----------------------------------------------------------------------------------------

    moveBlockToPosition(to) {
      
      var from = this.movingBlockFromPosition
      
      if( to < 0 ) to = 0
      if( to > this.blocks_local.length -1 ) to = this.blocks_local.length -1

      if( to > from ) to -= 1

      //console.log(from,to)
      //return

      var from = this.movingBlockFromPosition

      this.blocks_local.splice(to, 0, this.blocks_local.splice(from, 1)[0])

      this.movingBlockFromPosition = undefined


    },

//-----------------------------------------------------------------------------------------

    showPieceMediaMetaBtn(piece){
      if( this.pieceIsEmpty(piece) ) return
      if( !piece.metadata ) return false
      if( !piece.metadata.media ) return false
      return true
    },

//-----------------------------------------------------------------------------------------

    pieceMediaMetaBtnClick(piece){
      var media = piece.metadata.media
      this.modal_open({ modal:'media_edit_links', media: media })
    },

//-----------------------------------------------------------------------------------------


  }, //methods

  watch: {

    blocks_local(){
      this.movingBlockFromPosition = undefined // if moving blocks, stop that plz
    },

  },

  created(){

    console.log(this.$vue)

  },

  mounted(){

    //console.log( this.content )

    //if( !this.content_metadata.id && !this.content_metadata.page_key ) {
    //  Site.alert('Error: Missing layout id/pagekey...')
    //}
    

    var blocks = this.blocks
    if( blocks === undefined ) blocks = []
    this.blocks_local = JSON.parse(JSON.stringify(blocks))

    this.content_modified = false

    var _this = this

    setTimeout(()=>{
      _this.content_modified = false
    },0)
    
    
    //Site.bigSpinner(false)
    
  },

  watch: {

    blocks_local: {
      handler(val){
        this.content_modified = true
        console.log('changed')
      },      
      deep: true,
    }

  },

  created(){

    var _this = this

    eventBus.$on('blockEditor_exit', function(){ _this.on_click_exit_btn() })
    eventBus.$on('blockEditor_save', function(){ _this.on_click_save_btn() })

    document.body.classList.add('layoutblock-editor-active')

  },

  destroyed(){
    document.body.classList.remove('layoutblock-editor-active')
  },

}
</script>



// WEBPACK FOOTER //
// src/views/admin/AdminBlockEditor.vue